module.exports = __webpack_public_path__ + "static/img/p3.5dfce5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productimg/p3.png
// module id = eSq+
// module chunks = 0